import { createBrowserRouter, Navigate } from "react-router-dom"
import { AppLayout, AuthLayout, PublicLayout } from "@/components/layout/app-layout"
import { ProtectedRoute } from "@/components/auth/protected-route"
import { LoginPage } from "@/pages/auth/login"
import { RegisterPage } from "@/pages/auth/register"
import { DashboardPage } from "@/pages/dashboard"
import { ActivityPage } from "@/pages/activity"
import { ExpensesPageWrapper } from "@/pages/expenses-wrapper"
import { ExpenseImportPage } from "@/pages/expense-import"
import { ExpenseDuplicatesPage } from "@/pages/expense-duplicates"
import { RecurringExpensesPage } from "@/pages/recurring"
import { GroupsPage } from "@/pages/groups"
import { CategoriesPage } from "@/pages/categories"
import { SettingsPage } from "@/pages/settings"
import { JoinGroupPage } from "@/pages/join-group"
import { NotFoundPage } from "@/pages/not-found"

export const router = createBrowserRouter([
  {
    path: "/",
    element: <ProtectedRoute />,
    children: [
      {
        path: "/",
        element: <AppLayout />,
        children: [
          {
            index: true,
            element: <DashboardPage />,
          },
          {
            path: "expenses",
            element: <ExpensesPageWrapper />,
          },
          {
            path: "expenses/import",
            element: <ExpenseImportPage />,
          },
          {
            path: "expenses/duplicates",
            element: <ExpenseDuplicatesPage />,
          },
          {
            path: "recurring",
            element: <RecurringExpensesPage />,
          },
          {
            path: "activity",
            element: <ActivityPage />,
          },
          {
            path: "groups",
            element: <GroupsPage />,
          },
          {
            path: "categories",
            element: <CategoriesPage />,
          },
          {
            path: "settings",
            element: <SettingsPage />,
          },
        ],
      },
    ],
  },
  {
    path: "/auth",
    element: <AuthLayout />,
    children: [
      {
        path: "login",
        element: <LoginPage />,
      },
      {
        path: "register",
        element: <RegisterPage />,
      },
      {
        index: true,
        element: <Navigate to="/auth/login" replace />,
      },
    ],
  },
  {
    path: "/join/:inviteCode",
    element: <PublicLayout />,
    children: [
      {
        index: true,
        element: <JoinGroupPage />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
])
